import Vue from "vue";

export const sendSlackDemoRequest = (payload) => {
    return Vue.axios.post(
        `/private/ui/demo`,
        payload,
    );
};